import { useQueryClient } from '@tanstack/react-query';
import {
  SourcingChannelStatus,
  SourcingOpeningChannelsResponse,
} from 'api-clients/monolith';
import { useCallback } from 'react';

import { queryKeys } from '@/query-keys';

/**
 * Returns a callback that optimistically updates a campaign's status in the
 * cached channels-list response. Used to reflect toggle actions immediately
 * without waiting for a refetch.
 */
export function useSetCampaignStatus() {
  const queryClient = useQueryClient();

  return useCallback(
    (sourcingPurchaseId: string, status: SourcingChannelStatus) => {
      queryClient.setQueriesData<SourcingOpeningChannelsResponse>(
        { queryKey: queryKeys.openingDetails.channels.list },
        old =>
          old && {
            ...old,
            active_channels: old.active_channels.map(campaign =>
              campaign.sourcing_purchase_id === sourcingPurchaseId
                ? { ...campaign, status }
                : campaign,
            ),
          },
      );
    },
    [queryClient],
  );
}
